import { ICustomGroups, TMediaFileType } from 'types';

// localGroup.key is the carousel key
export const isHideButtonInCarousel = (localGroup: ICustomGroups, typeOfButton: TMediaFileType) => {
	if (localGroup.key === 'how_it_works' && typeOfButton === 1) {
		const countOfFiles = localGroup.items.filter((el) => el.mediaFileType === 1).length;
		const maximumAllowableCountOfFiles = 10;
		return countOfFiles >= maximumAllowableCountOfFiles;
	}
	if (localGroup.key === 'how_it_works' && typeOfButton === 2) {
		const countOfFiles = localGroup.items.filter((el) => el.mediaFileType === 2).length;
		const maximumAllowableCountOfFiles = 1;
		return countOfFiles >= maximumAllowableCountOfFiles;
	}
	if (localGroup.key === 'free_right_button' && typeOfButton === 1) {
		const countOfFiles = localGroup.items.filter((el) => el.mediaFileType === 1).length;
		const maximumAllowableCountOfFiles = 10;
		return countOfFiles >= maximumAllowableCountOfFiles;
	}
	if (localGroup.key === 'free_right_button' && typeOfButton === 2) {
		const countOfFiles = localGroup.items.filter((el) => el.mediaFileType === 2).length;
		const maximumAllowableCountOfFiles = 10;
		return countOfFiles >= maximumAllowableCountOfFiles;
	}
	if (localGroup.key === 'screen_saver_for_ordering' || localGroup.key === 'screen_saver_without_ordering') {
		const countOfFiles = localGroup.items.length;
		const defaultAllowableCountOfFiles = 20;
		return countOfFiles >= defaultAllowableCountOfFiles;
	}
	const countOfFiles = localGroup.items.length;
	const defaultAllowableCountOfFiles = 10;
	return countOfFiles >= defaultAllowableCountOfFiles;
};
